import Card from '@/components/marketing/Card'

interface FeatureCardProps {
  title: string
  desc: string
  color: string
  /**
   * 'card' (default) keeps the bordered card every tool page uses today.
   * 'row' renders a plain list row with no bordered box — used by the
   * tool-entry-v2 treatment so non-interactive items stop reading as
   * clickable (Clarity dead-click remediation). Do not change the default.
   */
  variant?: 'card' | 'row'
}

export function FeatureCard({
  title,
  desc,
  color,
  variant = 'card',
}: FeatureCardProps) {
  if (variant === 'row') {
    return (
      <div className='flex items-start gap-2.5 text-left'>
        <span
          className='h-2 w-2 mt-1.5 shrink-0'
          style={{ backgroundColor: color }}
        />
        <div>
          <span className='text-sm font-semibold text-foreground'>{title}</span>
          <p className='text-xs text-foreground/70 mt-0.5'>{desc}</p>
        </div>
      </div>
    )
  }

  return (
    <Card variant='outlined' padding='compact' className='bg-background'>
      <div className='flex items-center gap-2 mb-1.5'>
        <span className='h-2 w-2' style={{ backgroundColor: color }} />
        <span className='text-sm font-semibold text-foreground'>{title}</span>
      </div>
      <p className='text-xs text-foreground/70'>{desc}</p>
    </Card>
  )
}
